import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  /*
  {
    name: 'id',
    label: i18n('entities.category.fields.id'),
  },
  */
  {
    name: 'name',
    label: i18n('entities.category.fields.name'),
  },
  {
    name: 'colour',
    label: i18n('entities.category.fields.colour'),
  },
  {
    name: 'publicCategory',
    label: i18n('entities.category.fields.publicCategory'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'inContactForm',
    label: i18n('entities.category.fields.inContactForm'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'inSearch',
    label: i18n('entities.category.fields.inSearch'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'displayOrder',
    label: i18n('entities.category.fields.displayOrder'),
  },
  /*
  {
    name: 'createdAt',
    label: i18n('entities.category.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.category.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
  */
];
